export const POINT_SIZE = 14
export const LINE_OFFSET = 8
export const PROJECT_HEIGHT = 42
export const CHILD_HEIGHT = 24
export const CHILD_WITH_DETAILS_HEIGHT = 116
export const ITEM_HEIGHT = 48
export const ITEM_WITH_DETAILS_HEIGHT = 152
export const ITEM_WIDTH = 256
export const SPACING = 16
const HORIZONTAL_INNER_SPACING = 24
export const getPadding = (itemHeight: number) => ({
  top: (SPACING + POINT_SIZE / 2) as number,
  right: ITEM_WIDTH + SPACING - POINT_SIZE / 2,
  bottom: itemHeight + SPACING - POINT_SIZE / 2,
  left: (SPACING + POINT_SIZE / 2) as number,
})
export const VERTICAL_ICON_COMPENSATION = 1
export const HORIZONTAL_POINT_SPACING: number = ITEM_WIDTH + HORIZONTAL_INNER_SPACING
